<template>
  <div id="payment-element" class="payment-element w-100"></div>
</template>

<script>
import {loadStripe} from '@stripe/stripe-js'

export default {
  data() {
    return {
      stripe: null,
      clientSecret: null,
      elements: null,
      paymentElement: null,
      paymentIntentId: null,
    }
  },

  async mounted() {
    try {
      let publishableKey = _.get(apr, 'stripe.publishable_key');
      this.stripe = await loadStripe(publishableKey);

      this.paymentIntentId = _.get(apr, 'stripe.payment_intent_id');
      this.clientSecret = _.get(apr, 'stripe.client_secret');
      this.elements = this.stripe.elements({
        clientSecret: this.clientSecret,
        locale: 'en',
      });
      this.paymentElement = this.elements.create('payment');

      this.paymentElement.mount('#payment-element');

      this.setPaymentElementListener();
      this.setEventListeners();
    } catch (e) {
      console.error(e);
    }
  },

  methods: {
    setPaymentElementListener() {
      // Listen to changes in the Payment Element
      this.paymentElement.on('change', (event) => {
        if (event.complete) {
          console.log("Payment method is selected and valid");
          this.$emit('update-submit-disabled-state', false);

          return;
        }

        console.log("Payment method not ready yet");
        this.$emit('update-submit-disabled-state', true);
      });
    },

    setEventListeners() {
      this.$root.$on(`checkout::reservation-submitted`, async () => {
        const {error: submitError} = await this.elements.submit();
        if (submitError) {
          console.error('Validation error:', submitError.message);
          return;
        }

        const {confirmationToken, error} = await this.stripe.createConfirmationToken({
          elements: this.elements,
          locale: 'en',
        });

        if (error) {
          this.$root.$emit('fatal-error', 'Failed to create confirmation token:', error.message);
          console.log('Failed to create confirmation token: ' + error.message);
        } else {
          this.$root.$emit('gateway-changed', {
            gateway: 'stripe',
            gateway_data: {
              'payment_intent_id': this.paymentIntentId,
              'confirmation_token': confirmationToken.id,
            },
          });

          this.$root.$emit('checkout::credit-card-was-validated');
          console.log('Got confirmation token:', confirmationToken.id);
        }
      });

      this.$root.$on(`checkout::additional-actions-required`, async (data) => {
        // Stripe SDK scenario
        if (_.get(data, 'type') === 'use_stripe_sdk') {
          let clientSecret = _.get(data, 'client_secret');
          const {error} = await this.stripe.handleNextAction({
            clientSecret,
            locale: 'en',
          });

          if (error) {
            console.error('Validation error: ' + _.get(error, 'code'));
            this.$root.$emit('payment-container::verification-failed', this.messageEnByCode(error));
          } else {
            window.location.href = `/stripe-payment/wait/${this.paymentIntentId}`;
          }
        }

        // Redirect scenario
        if (_.get(data, 'type') === 'redirect_to_url') {
          window.location.href = _.get(data, 'redirect_to_url');
        }

      });

      this.$root.$on(`checkout::payment-intent-updated`, async (data) => {
        this.paymentIntentId = _.get(data, 'payment_intent_id');
        this.clientSecret = _.get(data, 'client_secret');

        this.elements.update({
          clientSecret: this.clientSecret,
        });

        console.log('Payment elements was updated');
      });
    },

    messageEnByCode(error) {
      let errorCode = _.get(error, 'code')

      const messages = {
        authentication_error: 'Authentication failed. Please try another payment method.',
        payment_intent_authentication_failure: '3-D Secure authentication failed.',
        payment_intent_unexpected_state: 'Payment is not in a state that can be confirmed.',
        card_declined: 'Your card was declined.',
        insufficient_funds: 'Insufficient funds.',
        expired_card: 'Your card has expired.',
        incorrect_cvc: 'Incorrect CVC.',
        processing_error: 'An error occurred while processing the card.',
        invalid_request_error: 'Invalid payment request. Please try again.',
      };

      return _.get(messages, errorCode, 'Verification failed. Please try another card or payment method.')
    }
  },
}
</script>
